import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import {TranslationProvider} from "./context/translationContext";
import Downloads from "./apps/Downloads";
import {getJsonDataFromDataAttribute} from "./utility/jsonDataExctractor";
import {getPrimitiveValueFromDataAttribute} from "./utility/jsonDataExctractor";

const downloadsRoot : Element | null = document.querySelector('[data-internezzo-downloads-downloads]');

if(downloadsRoot !== null) {

    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    const urlTag = params.get('tag');

    const filterTags = getJsonDataFromDataAttribute(downloadsRoot, 'internezzo-downloads-downloads-tags');
    const singleTag = urlTag ? urlTag : getPrimitiveValueFromDataAttribute(downloadsRoot, 'internezzo-downloads-downloads-tag');

    const translationScriptTag = document.querySelector('[data-internezzo-downloads-downloads-translations]');
    const translations = JSON.parse(translationScriptTag ? translationScriptTag.innerHTML : '[]');

    ReactDOM.render(
        <TranslationProvider value={translations}>
            <Downloads
                filterTags={filterTags}
                singleTag={singleTag}
            />
        </TranslationProvider>,
        downloadsRoot
    );

}
